var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastmove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MOUSE_MAP_LAST_MOVE_SYMBOL",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lastmove",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    fill: "#26A95F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.355469 7.18431C0.355469 3.49267 3.34814 0.5 7.03978 0.5C10.7314 0.5 13.7241 3.49267 13.7241 7.18431C13.7241 10.876 10.7314 13.8686 7.03978 13.8686C3.34814 13.8686 0.355469 10.876 0.355469 7.18431Z",
    fill: "#26A95F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastmove);
export default __webpack_public_path__ + "static/media/lastmove.8ab994aa59dc778a618710b035093a1a.svg";
export { ForwardRef as ReactComponent };